const PUBLIC_PATHS = ['/login', '/forgot-password']

export const isPublicPath = (pathname: string) => PUBLIC_PATHS.some((p) => pathname.startsWith(p))
